<template>
  <v-app style=" background: none !important;">
    <router-view/>
  </v-app>
</template>

<script>
import '@/components/css/style.css'
export default {
  name: 'App'
}
</script>



// WEBPACK FOOTER //
// src/App.vue